<template>
  <v-card class="bordered-card">
    <slot></slot>
  </v-card>
</template>

<script>
export default {
  name: "BorderedCard",
};
</script>

<style lang="scss" scoped>
.bordered-card {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  padding: 20px 16px;
  display: flex;
}
</style>
